import { TablePaginationConfig } from "antd";
import { walletsApi } from "api/wallet";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { ITableData, defaultTableData } from "models";
import { IDriverWallet } from "models/driverWallet";
import { ChangeEvent, useEffect, useState } from "react";

export default function useDriverWallet() {
  const { showError } = useNotificationContext();
  const { reloadWallet } = useDataLoadingContext();
  const [data, setData] = useState<ITableData<IDriverWallet>>(defaultTableData);

  const [debouncedSearch, setDebouncedSearch] = useState(data.search);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(data.search);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [data.search]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [data.page, debouncedSearch, reloadWallet]);

  const fetchData = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    const { data: response, error } = await walletsApi(
      data.page,
      data.per_page,
      data.search,
      true // Enable Local Caching
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...response }));
    } else showError(error!.message);
    setData((prev) => ({ ...prev, loading: false }));
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({ ...prev, search: value ?? "", page: 1 }));
  };

  return { data, handlePageChange, handleSearch };
}
